import { format, getISODay, getHours } from 'date-fns';
import { map, Observable, take, timer } from 'rxjs';

export const SECOND_MILLISECONDS = 1000;
export const MINUTE_SECONDS = 60;
export const MINUTE_MILLISECONDS = SECOND_MILLISECONDS * MINUTE_SECONDS;

/**
 * @description Returns week hour index from 0 to 167
 * @param {Date} date
 * @return {number}
 */
export function getWeekHourIdx(date: Date): number {
  const day = getISODay(date);
  const hours = getHours(date);

  return day === 1 ? hours : (day - 1) * 24 + hours;
}

export function secondsTimer(seconds = 60, timeFormat = 'mm:ss'): Observable<string> {
  return timer(0, 1000).pipe(
    map((_, idx) => {
      return seconds - idx;
    }),
    take(seconds + 1),
    map((res) => {
      return format(new Date(0, 0, 0, 0, 0, res, 0), timeFormat);
    }),
  );
}

export function getFullYearFromDate(_date: Readonly<Date | string>): number | null {
  try {
    const today = new Date();
    const date = new Date(_date);

    let years = today.getFullYear() - date.getFullYear();

    if (
      today.getMonth() < date.getMonth() ||
      (today.getMonth() === date.getMonth() && today.getDate() < date.getDate())
    ) {
      years--;
    }

    return years;
  } catch (e) {
    return null;
  }
}
